var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu"},[_c('div',{staticClass:"box"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/kefu_left.png"),"alt":""}}),_c('p',[_vm._v("扫码联系客服")])]),_c('div',[_c('img',{attrs:{"src":require("@/assets/images/kefu_right.png"),"alt":""}}),_c('p',[_vm._v("小程序")])])])])
}]

export { render, staticRenderFns }